import { render, staticRenderFns } from "./ClothesToRental.vue?vue&type=template&id=39ab37b8&"
import script from "./ClothesToRental.vue?vue&type=script&lang=js&"
export * from "./ClothesToRental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports